import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookingWidget from "@/pages/BookingWidget";
import ManageReservation from "@/pages/ManageReservation";
import AdminDashboard from "@/pages/AdminDashboard";
import Customers from "@/pages/Customers";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Set the document title and ensure it's not overwritten
    document.title = "Pizzeria Piazza - Reservieren";
    
    // Create a MutationObserver to watch for title changes
    const observer = new MutationObserver((mutations) => {
      if (document.title !== "Pizzeria Piazza - Reservieren") {
        document.title = "Pizzeria Piazza - Reservieren";
      }
    });
    
    // Observe the title element
    const titleElement = document.querySelector('title');
    if (titleElement) {
      observer.observe(titleElement, { childList: true });
    }
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookingWidget />} />
          <Route path="/manage/:reservationId" element={<ManageReservation />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/customers" element={<Customers />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;